export default {
  'other': 'en',
  'en': [ 'en_GB'],
  'de': [ 'de_DE'],
  'deu': [ 'de_DE'],
  'es': [ 'es_ES'],
  'fr': [ 'fr_FR'],
  'ca': [ 'en_GB'],
  'sv': [ 'sv_SE'],
  'se': [ 'sv_SE'],
  'pt': [ 'pt_PT'],
  'pl': [ 'pl_PL'],
  'ru': [ 'ru_RU'],
  'ro': [ 'ro_RO'],
  'fi': [ 'fi_FI'],
  'it': [ 'it_IT'],
  'dk': [ 'da_DK'],
  'da': [ 'da_DK'],
  'no': [ 'nb_NO', 'no_NO' ]
};
